export const MenuArrow = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.00016 19.9201L15.5202 13.4001C16.2902 12.6301 16.2902 11.3701 15.5202 10.6001L9.00016 4.08008" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};